import { ReactNode } from 'react';

/**
 * Carte de réglage à l'intérieur d'une section.
 * Regroupe visuellement des champs liés avec un titre et une icône.
 *
 * Exemple :
 *   <SettingCard title="Logo" icon={<Image />}>
 *       <Upload ... />
 *   </SettingCard>
 */
const SettingCard = (props: {
    title: ReactNode;
    icon?: ReactNode;
    children: ReactNode;
}) => (
    <div className="eb-setting-card">
        <div className="eb-setting-card-head">
            {props.icon && <span className="eb-setting-card-icon">{props.icon}</span>}
            <h4 className="eb-setting-card-title">{props.title}</h4>
        </div>
        <div className="eb-setting-card-body">
            {props.children}
        </div>
    </div>
);

export default SettingCard;
